import { createContext, useContext, useState } from 'react';
import { getCookie } from '../services/cookies';

const BoxContext = createContext();

export const useBoxContext = () => useContext(BoxContext);

export const BoxProvider = ({ children }) => {
  const initialValue = getCookie('branch_office_has_boxes') === 'true';
  const [hasBoxes, setHasBoxes] = useState(initialValue);

  return (
    <BoxContext.Provider value={{ hasBoxes, setHasBoxes }}>
      {children}
    </BoxContext.Provider>
  );
};